import * as d3 from 'd3'
export default {
  methods: {

    dia_Dropdown(selection, data_, props) {

      let chartMenu = selection
      .append('g')
      .attr('id', `DROPDOWN_${props.id}`)
      .attr('transform', `translate(${props.x}, ${props.y})`)
      .attr('font-family','roboto')

      chartMenu
      .append('text')
      .attr('id', `LABEL_${props.id}`)
      .attr('x', 0).attr('y', 0)
      .attr('fill', '#333') .attr('font-size', 10).attr('font-style', 'italic')
      .text(props.label)

      let dropdown = chartMenu
      .append('g')
      .attr('transform', `translate(${0}, ${5})`)

      dropdown
      .append('rect')
      .attr('id', `DROP_BOX_${props.id}`)
      .attr('width', props.boxWidth).attr('height', 20)
      .attr('fill', '#fcfcfc').attr('stroke','#757575').attr('stroke-width', 1).attr('stroke-opacity', .3)

      dropdown
      .append('path')
      .attr('id', `ARROW_${props.id}`)
      .attr('transform', `translate(${props.boxWidth - 12} ,7)`).attr('fill', '#bcbcbc')
      .attr('d',`M3.9,4.6C4,4.6,7.9,1,7.9,1l-1-1l-3,2.9L1,0L0,1C0,1,3.9,4.6,3.9,4.6z`)

      dropdown
      .append('text')
      .attr('id', `DIA_${props.id}`)
      .attr('x', props.icon ? 27 : 5).attr('y', 10 + 12*0.36)
      .attr('fill', '#333') .attr('font-size', 11)
      .text(`${data_[0].name} (${data_[0].count})`)

      if(props.icon) {
        dropdown
        .append('image')
        .attr('id', `ICON_${props.icon}`)
        .attr('xlink:href', this.HOST + `/Database/icon/DB_Blank.svg`).attr('x', 7).attr('y', 3).attr('height', 13)
      }

      dropdown
      .on('mouseover', () => { 
        dropdown.attr('cursor', 'pointer')
        d3.select(`#DIA_${props.id}`).attr('fill','#44A9DF')
        d3.select(`#DROP_BOX_${props.id}`).attr('stroke','#44A9DF')
      })
      .on('mouseout', (event) => { 
        dropdown.attr('cursor', 'default')
        d3.select(`#DIA_${props.id}`).attr('fill', '#333')
        d3.select(`#DROP_BOX_${props.id}`).attr('stroke','#757575')

        const [x, y] = d3.pointer(event, dropdown)
        let x1 = this.getNode(`#DROP_BOX_${props.id}`, 'x')+1,
            x2 = x1 + this.getNode(`#DROP_BOX_${props.id}`, 'width')-3,
            y1 = this.getNode(`#DROP_BOX_${props.id}`, 'y')+1
        if(x<x1 || x>x2 || y< y1) d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'hidden')
      })
      .on('click', () => { 
        if (d3.select(`#DROP_ITEM_${props.id}`).attr('visibility') == 'hidden') {
          d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'visible')
          d3.select(`#ARROW_${props.id}`).attr('transform', `translate(${props.boxWidth - 4} ,11) rotate(180)`)
        } else {
          d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'hidden')
          d3.select(`#ARROW_${props.id}`).attr('transform', `translate(${props.boxWidth - 12} ,7) rotate(0)`)
        }
      })

      this.dia_DropItems(data_, props) //-----> below
    },



    dia_DropItems(data_, props) {

      d3.select(`#DROP_ITEM_${props.id}`).remove()

      let items = d3.select(`#DROPDOWN_${props.id}`)

      .append('g')
      .attr('id',`DROP_ITEM_${props.id}`)
      .attr('transform', `translate(0, 25)`).attr('visibility', 'hidden')

      items
      .append('rect')
      .attr('width', props.boxWidth).attr('height', (data_.length * (18))+3)
      .attr('fill', '#f9f9f9').attr('stroke','#bcbcbc').attr('stroke-width',0.5)

      data_.forEach((item, i) => {
        items
        .append('rect')
        .attr('id', `ITEM_BOX_${props.id}_${i}`)
        .attr('x', 1).attr('y', (i * 18)+1)
        .attr('width', props.boxWidth-2).attr('height', 18).attr('fill', '#fff').attr('opacity', .5)
        
        items
        .append('text')
        .attr('id', `ITEM_TEXT_${props.id}_${i}`)
        .attr('x', props.icon ? 27 : 7).attr('y', (i * 18) + 10.5 + 12*0.36).attr('fill', '#757575') .attr('font-size', 10)
        .text(`${item.name} (${item.count})`)

        items
        .datum(item.name)
        .append('rect')
        .attr('id', `optionBtn_${props.id}_${i}`)
        .attr('x', 1).attr('y', i * 18).attr('width', props.boxWidth-2).attr('height', 18)
        .attr('fill', 'transparent').attr('stroke','transparent').attr('stroke-width',0.5)
        .attr('cursor', 'pointer')
        .on('mouseover', () => { 
          d3.select(`#ITEM_BOX_${props.id}_${i}`).transition().duration(100).attr('fill','#B4E3FA')
          d3.select(`#ITEM_TEXT_${props.id}_${i}`).attr('fill','#000')
        })
        .on('mouseout', (event) => { 
          d3.select(`#ITEM_BOX_${props.id}_${i}`).transition().duration(100).attr('fill','transparent')
          d3.select(`#ITEM_TEXT_${props.id}_${i}`).attr('fill','#757575')

          const [x, y] = d3.pointer(event, item.name)
          let x1 = this.getNode(`#DROP_ITEM_${props.id}`, 'x')+1,
              x2 = x1 + this.getNode(`#DROP_ITEM_${props.id}`, 'width')-3,
              y1 = this.getNode(`#DROP_ITEM_${props.id}`, 'y')+1,
              y2 = y1 + this.getNode(`#DROP_ITEM_${props.id}`, 'height')-4
          if(x<x1 || x>x2 || y< y1 || y>=y2) d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'hidden')
        })
        .on('click', (d) => { 
          d3.select(`#DIA_${props.id}`).text(item.name + `(${item.count})`)
          if(props.icon) d3.select(`#ICON_${props.icon}`).attr('xlink:href', this.HOST + `/Database/icon/DB_${data_[i]}.svg`)
          d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'hidden')
          d3.select(`#ARROW_${props.id}`).attr('transform', `translate(${props.boxWidth - 12} ,7) rotate(0)`)
          items.attr('visibility', 'hidden')

          this.current.handover = item.code
          this.current.page = 1
          this.filteringData()
          
          this.canvasSystems.remove()
          this.draw_SystemList()
        })
      })
      
    },

  } 
}